import { render, staticRenderFns } from "./VInputFlutuante.vue?vue&type=template&id=615f2d7b&scoped=true&"
import script from "./VInputFlutuante.vue?vue&type=script&lang=js&"
export * from "./VInputFlutuante.vue?vue&type=script&lang=js&"
import style0 from "./VInputFlutuante.vue?vue&type=style&index=0&id=615f2d7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615f2d7b",
  null
  
)

export default component.exports